// extracted by mini-css-extract-plugin
module.exports = {"html5videoplayer":"_2OLDoyivZvkQgCJOtvQ0W9","html5Videoplayer":"_2OLDoyivZvkQgCJOtvQ0W9","html5audioplayer":"_29LHTyIQhvFg_DQxx4tvD6","html5Audioplayer":"_29LHTyIQhvFg_DQxx4tvD6"};